import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Children } from "react";
import { ArticleCard, StoryCard } from "@vfit/shared/components";
import { EffectCards, FreeMode, Keyboard, Mousewheel, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDeviceType } from "@vfit/shared/hooks";
import { purify } from "@vfit/shared/themes";
import { getSlideSize } from "./CarouselStories.utils";
import { StoryArticleContainer, Title } from "./CarouselStories.style";
var CarouselStories = function(param) {
    var storiesArticles = param.storiesArticles, title = param.title, isLight = param.isLight;
    var ref = _sliced_to_array(purify([
        title || ""
    ]), 1), pTitle = ref[0];
    var ref1 = useDeviceType(), isMobile = ref1.isMobile, isTablet = ref1.isTablet, isDesktop = ref1.isDesktop;
    var bulletClass = isLight ? "swiper-pagination-bullet-exp" : "swiper-pagination-bullet";
    var bulletActiveClass = isLight ? "swiper-pagination-bullet-active-exp" : "swiper-pagination-bullet-active";
    var getStoriesAndArticles = function(variant) {
        return storiesArticles.map(function(el) {
            if (el.type === "story") return /*#__PURE__*/ _jsx(StoryCard, {
                title: el === null || el === void 0 ? void 0 : el.title,
                topic: el === null || el === void 0 ? void 0 : el.topic,
                creator: el === null || el === void 0 ? void 0 : el.creator,
                backgroundImg: el === null || el === void 0 ? void 0 : el.backgroundImg,
                ellipseImg: el === null || el === void 0 ? void 0 : el.ellipseImg,
                variant: variant,
                ignoreSize: true
            });
            return /*#__PURE__*/ _jsx(ArticleCard, {
                title: el === null || el === void 0 ? void 0 : el.title,
                topic: el === null || el === void 0 ? void 0 : el.topic,
                creator: el === null || el === void 0 ? void 0 : el.creator,
                backgroundImg: el === null || el === void 0 ? void 0 : el.backgroundImg,
                pillText: el === null || el === void 0 ? void 0 : el.pillText,
                variant: variant,
                ignoreSize: true
            });
        });
    };
    var swiperSolutions = function(type) {
        var ref;
        /*#__PURE__*/ return _jsx(Swiper, {
            slidesPerView: "auto",
            effect: type,
            cardsEffect: {
                rotate: true,
                slideShadows: false
            },
            spaceBetween: 32,
            freeMode: false,
            mousewheel: {
                forceToAxis: true
            },
            centeredSlides: isMobile,
            keyboard: true,
            pagination: {
                bulletClass: bulletClass,
                bulletActiveClass: bulletActiveClass,
                clickable: true
            },
            modules: [
                Pagination,
                FreeMode,
                Mousewheel,
                Keyboard,
                EffectCards
            ],
            children: Children.toArray((ref = getStoriesAndArticles(isMobile || isTablet ? "small" : "large")) === null || ref === void 0 ? void 0 : ref.map(function(StoryArticle, index) {
                var marginLeft = 0;
                if (index === 0) {
                    if (isDesktop) marginLeft = 80;
                    else if (isTablet) marginLeft = 32;
                }
                if (index === 0 && isMobile) marginLeft = 0;
                var customSize = getSlideSize(isMobile, isTablet);
                return /*#__PURE__*/ _jsx(SwiperSlide, {
                    style: _object_spread({
                        marginLeft: marginLeft
                    }, customSize),
                    children: StoryArticle
                });
            }))
        });
    };
    return /*#__PURE__*/ _jsxs(StoryArticleContainer, {
        children: [
            pTitle && /*#__PURE__*/ _jsx(Title, {
                dangerouslySetInnerHTML: {
                    __html: pTitle
                }
            }),
            isMobile && swiperSolutions("cards"),
            !isMobile && swiperSolutions("slide")
        ]
    });
};
export default CarouselStories;
